import React from 'react';
import {
  Box, Modal, Typography, TextField, Button
} from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 24,
  p: 3,
};

const UserCommentModal = ({
  open,
  onClose,
  onSave,
  commentText = '',
  setCommentText,
  mode = 'add',
  author = '',
  date = '',
  loading = false,
}) => {
  const isViewMode = mode === 'view';

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Typography variant="h6" mb={2}>
          {isViewMode ? 'View Comment' : 'Add Comment'}
        </Typography>
        {isViewMode && (author || date) && (
          <Typography variant="subtitle2" color="text.secondary" mb={1}>
            {author && <>By <b>{author}</b></>}
            {author && date && ' · '}
            {date && <>{date}</>}
          </Typography>
        )}
        <TextField
          fullWidth
          multiline
          rows={4}
          placeholder={isViewMode ? 'No comment available.' : 'Write your comment here...'}
          value={commentText}
          onChange={(e) => setCommentText && setCommentText(e.target.value)}
          InputProps={{
            readOnly: isViewMode,
          }}
        />
        <Box mt={2} display="flex" justifyContent="flex-end" gap={1}>
          <Button variant="outlined" onClick={onClose} disabled={loading}>Close</Button>
          {!isViewMode && (
            <Button
              variant="contained"
              onClick={onSave}
              disabled={loading || !commentText.trim()}
            >
              {loading ? 'Saving...' : 'Save'}
            </Button>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default UserCommentModal;
